var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eden-activity-icon",style:({
    backgroundColor: `${_vm.colors[_vm.event]}`
  })},[_c('img',{attrs:{"src":_vm.getImage(`activities/${_vm.event}.svg`),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }